/* v18 */
// Kuvr Cost Page — Reveals, Swiper, Chart, Animations
// Works on standalone page AND inside kuvr-modal

function initCostPage() {
  var wrap = document.querySelector('.kuvr-cost-page');
  if (!wrap || wrap.dataset.costInit) return;
  wrap.dataset.costInit = '1';

  // Detect modal context
  var scrollContainer = wrap.closest('.kuvr-modal__content') || null;
  var isInModal = !!scrollContainer;

  // Force lazy images in modal
  if (isInModal) {
    wrap.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      img.removeAttribute('loading');
      var src = img.src; img.src = ''; img.src = src;
    });
  }

  // === REVEAL OBSERVER ===
  var revealOpts = isInModal
    ? { root: scrollContainer, rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    : { threshold: 0.15, rootMargin: '0px 0px -40px 0px' };

  var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
        setTimeout(function() {
          entry.target.querySelectorAll('.timeline-standard, .timeline-kuvr').forEach(function(row) {
            row.classList.add('animated');
          });
        }, 200);
      }
    });
  }, revealOpts);

  wrap.querySelectorAll('.reveal').forEach(function(el) {
    revealObserver.observe(el);
  });

  // === TIMELINE BAR ANIMATION ===
  function animateBar(bar, targetPct, delay) {
    setTimeout(function() {
      var start = null;
      var duration = 1500;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        bar.style.width = (eased * targetPct) + '%';
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, delay);
  }

  var timelineContainer = wrap.querySelector('.timeline-container');
  if (timelineContainer) {
    var tlOpts = isInModal
      ? { root: scrollContainer, threshold: 0.01, rootMargin: '0px 0px 200px 0px' }
      : { threshold: 0.01, rootMargin: '0px 0px 200px 0px' };
    var tlObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          var standardBar = entry.target.querySelector('.timeline-standard .timeline-bar');
          var kuvrBar = entry.target.querySelector('.timeline-kuvr .timeline-bar');
          if (standardBar) animateBar(standardBar, 100, 200);
          if (kuvrBar) animateBar(kuvrBar, 40, 500);
          tlObserver.unobserve(entry.target);
        }
      });
    }, tlOpts);
    tlObserver.observe(timelineContainer);
  }

  // === COUNT-UP ANIMATION ===
  function countUp(el, target, duration) {
    var start = null;
    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = '$' + Math.round(eased * target);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var compSection = wrap.querySelector('.comparison');
  if (compSection) {
    var cardOpts = isInModal
      ? { root: scrollContainer, threshold: 0.3 }
      : { threshold: 0.3 };
    var cardObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('.card-total-amount').forEach(function(amt) {
            var val = parseInt(amt.textContent.replace(/[^0-9]/g, ''));
            if (val > 0) countUp(amt, val, 2500);
          });
          cardObserver.unobserve(entry.target);
        }
      });
    }, cardOpts);
    cardObserver.observe(compSection);
  }

  // === CHART ===
  var chartCreated = false;
  var chartEl = wrap.querySelector('#costChart');
  if (chartEl && typeof Chart !== 'undefined') {
    var chartOpts = isInModal
      ? { root: scrollContainer, threshold: 0.3 }
      : { threshold: 0.3 };
    var chartObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !chartCreated) {
          chartCreated = true;
          chartObserver.unobserve(entry.target);
          var ctx = chartEl.getContext('2d');
          new Chart(ctx, {
            type: 'bar',
            data: {
              labels: ['Standard Cover', 'Kuvr Cover'],
              datasets: [{ label: 'Total Cost Over 10 Years', data: [500, 200], backgroundColor: ['#f1605f', '#006f6c'], borderWidth: 0, borderRadius: 6 }]
            },
            options: {
              responsive: true, maintainAspectRatio: true,
              animation: { duration: 2000, easing: 'easeOutQuart', delay: function(context) { return context.dataIndex * 300; } },
              plugins: { legend: { display: false }, title: { display: false }, tooltip: { backgroundColor: 'rgba(0,0,0,0.8)', padding: 12, bodyFont: { size: 14 }, callbacks: { label: function(context) { return '$' + context.parsed.y; } } } },
              scales: {
                y: { beginAtZero: true, max: 600, ticks: { stepSize: 100, callback: function(value) { return '$' + value; }, font: { size: 13, family: 'Lato' }, color: '#666' }, grid: { color: '#e8e8e8', drawBorder: false } },
                x: { ticks: { font: { size: 14, weight: '700', family: 'Lato' }, color: '#333' }, grid: { display: false } }
              },
              layout: { padding: { top: 20, bottom: 10, left: 10, right: 10 } }
            },
            plugins: [{ afterDatasetsDraw: function(chart) { var ctx2 = chart.ctx; chart.data.datasets.forEach(function(dataset, i) { var meta = chart.getDatasetMeta(i); meta.data.forEach(function(bar, index) { ctx2.fillStyle = '#333'; ctx2.font = 'bold 16px Lato'; ctx2.textAlign = 'center'; ctx2.textBaseline = 'bottom'; ctx2.fillText('$' + dataset.data[index], bar.x, bar.y - 10); }); }); } }]
          });
        }
      });
    }, chartOpts);
    chartObserver.observe(chartEl);
  }

  // === SWIPER CAROUSEL ===
  if (typeof Swiper !== 'undefined') {
    var swiperEl = wrap.querySelector('.mySwiper');
    if (swiperEl) {
      new Swiper(swiperEl, {
        slidesPerView: 'auto', centeredSlides: true, spaceBetween: 16, loop: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        navigation: { nextEl: wrap.querySelector('.swiper-button-next'), prevEl: wrap.querySelector('.swiper-button-prev') },
        breakpoints: { 640: { slidesPerView: 2 }, 900: { slidesPerView: 3 } }
      });
    }
  }

  // === FEATURED IMAGE ROTATIONS ===
  var el1 = wrap.querySelector('#featured-img');
  if (el1) {
    var imgs1 = [
      'https://cdn.shopify.com/s/files/1/0380/4171/4827/files/review-81G8xvf-plus-foL.jpg?v=1773754958',
      'https://cdn.shopify.com/s/files/1/0380/4171/4827/files/review-81IaVbem-DL.jpg?v=1773754961',
      'https://cdn.shopify.com/s/files/1/0380/4171/4827/files/review-81zznzT8tOL.jpg?v=1773754973'
    ];
    var idx1 = 0;
    setInterval(function() {
      el1.style.opacity = '0';
      setTimeout(function() {
        idx1 = (idx1 + 1) % imgs1.length;
        el1.src = imgs1[idx1];
        el1.style.opacity = '1';
      }, 600);
    }, 2500);
  }

  var el2 = wrap.querySelector('#featured-img-2');
  if (el2) {
    var imgs2 = [
      'https://cdn.shopify.com/s/files/1/0380/4171/4827/files/review-81m-plus-J4xa58L.jpg?v=1773754967',
      'https://cdn.shopify.com/s/files/1/0380/4171/4827/files/review-81C2glbJ44L.jpg?v=1773754974',
      'https://cdn.shopify.com/s/files/1/0380/4171/4827/files/review-81DsTGgpZ-plus-L.jpg?v=1773754976'
    ];
    var idx2 = 0;
    setInterval(function() {
      el2.style.opacity = '0';
      setTimeout(function() {
        idx2 = (idx2 + 1) % imgs2.length;
        el2.src = imgs2[idx2];
        el2.style.opacity = '1';
      }, 600);
    }, 2500);
  }
}

// Run on page load
initCostPage();

// Re-run when modal content is injected (same pattern as case study)
(function() {
  function watchModal() {
    var modalContent = document.getElementById('kuvrModalContent');
    if (!modalContent) return;
    var observer = new MutationObserver(function() {
      if (modalContent.querySelector('.kuvr-cost-page')) {
        setTimeout(initCostPage, 300);
      }
    });
    observer.observe(modalContent, { childList: true });
  }

  // Also intercept fetch to catch modal content loads
  var origFetch = window.fetch;
  window.fetch = function() {
    return origFetch.apply(this, arguments).then(function(response) {
      setTimeout(function() {
        var mc = document.getElementById('kuvrModalContent');
        if (mc && mc.querySelector('.kuvr-cost-page')) {
          initCostPage();
        }
      }, 500);
      return response;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchModal);
  } else {
    watchModal();
  }
})();
